import { useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import { ExecutionResult } from "graphql";
import gql from "graphql-tag";

import { Mutation } from "src/types/graphql.d";

interface SegmentIdentifyData {
  segmentIdentify: Mutation["segmentIdentify"];
}

interface SegmentIdentifyVars {
  anonymous_id: string;
  shopper_email: string;
}

interface UseSegmentIdentify {
  data?: SegmentIdentifyData | null;
  loading: boolean;
  error?: ApolloError;
  segmentIdentify: (
    anonymous_id: string,
    shopper_email: string
  ) => Promise<ExecutionResult<SegmentIdentifyData>>;
}

const SEGMENT_IDENTIFY = gql`
  mutation segmentIdentify($anonymous_id: String!, $shopper_email: String!) {
    segmentIdentify(
      data: { anonymous_id: $anonymous_id, shopper_email: $shopper_email }
    ) {
      success
    }
  }
`;

export const useSegmentIdentify = (): UseSegmentIdentify => {
  const [segmentIdentifyMutation, { loading, data, error }] = useMutation<
    SegmentIdentifyData,
    SegmentIdentifyVars
  >(SEGMENT_IDENTIFY);

  const segmentIdentify = useCallback(
    (anonymous_id: string, shopper_email: string) => {
      return segmentIdentifyMutation({
        variables: { anonymous_id, shopper_email },
      });
    },
    [segmentIdentifyMutation]
  );

  return { segmentIdentify, loading, data, error };
};
